import { render, staticRenderFns } from "./NoPhone.vue?vue&type=template&id=566f053e&scoped=true"
import script from "./NoPhone.vue?vue&type=script&lang=js"
export * from "./NoPhone.vue?vue&type=script&lang=js"
import style0 from "./NoPhone.vue?vue&type=style&index=0&id=566f053e&lang=scss&scoped=true"
import style1 from "./NoPhone.vue?vue&type=style&index=1&id=566f053e&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f053e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566f053e')) {
      api.createRecord('566f053e', component.options)
    } else {
      api.reload('566f053e', component.options)
    }
    module.hot.accept("./NoPhone.vue?vue&type=template&id=566f053e&scoped=true", function () {
      api.rerender('566f053e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modal/NoPhone.vue"
export default component.exports